import * as React from "react";

export function useBreadcrumb(label) {
  React.useEffect(() => {}, [label]);
}
